import { componentName, LogoClass } from './LogoClass';

customElements.define(componentName, LogoClass);

export { LogoClass, componentName };
